const arr =[{
	path:'details',
	component: resolve => {
		require(['../../../views/inner/product/new_opinion/details.vue'], resolve)
	}
},
{
	path:'list',
	component: resolve => {
		require(['../../../views/inner/product/new_opinion/list.vue'], resolve)
	}
}]

export default arr


// WEBPACK FOOTER //
// ./src/router/inner/product/new_opinion.js